export type WorkbenchBreakpointMap = Partial<Record<'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl', boolean>>;

/**
 * 是否应走 H5 路由 / 紧凑壳层。
 * 以视口宽度为主；小程序环境强制 H5。PC 端微信、宽屏 iPad 不单独判定为移动。
 */
export function detectMobileOrMiniProgram(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const inMiniProgram =
    (window as Window & { __wxjs_environment?: string }).__wxjs_environment === 'miniprogram' ||
    /\bminiProgram\b/i.test(ua);
  if (inMiniProgram) return true;
  return window.matchMedia('(max-width: 768px)').matches;
}

/**
 * 工作台内部是否使用移动布局（顶栏 Tab 等）。
 * Ant Design useBreakpoint 首帧 md 常为 undefined/false，不可直接用 !screens.md。
 */
export function resolveWorkbenchMobileLayout(
  screens: WorkbenchBreakpointMap,
  forceMobileLayout = false,
): boolean {
  if (forceMobileLayout) return true;
  if (screens.md === true) return false;
  if (screens.md === false && (screens.xs || screens.sm)) return true;
  return false;
}
